import { ListItem, Stack, Typography } from '@hiiretail/react-foundation-ui';
import { FC, ReactNode } from 'react';

interface ItemsSearchPlaceholderProps {
  icon: ReactNode;
  text: string;
}

const styles = {
  placeholderContainer: {
    flex: 1,
    flexDirection: 'row',
    gap: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
};

export const ItemsSearchPlaceholder: FC<ItemsSearchPlaceholderProps> = ({ icon, text }) => (
  <ListItem>
    <Stack sx={styles.placeholderContainer}>
      {icon}
      <Typography>{text}</Typography>
    </Stack>
  </ListItem>
);
